package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.list_device


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("listDevices")
    val listDevices: ListDevices?
)